<div class="settings-map-wrapper">
  <div class="content-center">

    <div class="standalone-loader" *ngIf="isLoading">
      <div class="spinner-border custom-blue-spinner" role="status"></div>
      <span class="loading-text">Loading data connections...</span>
    </div>

    <div *ngIf="!isLoading">
      <div class="tab-actions" [class.dimmed]="showNewInline">
        <a class="new-service-link" (click)="openNewConnection()">New External Connection</a>
      </div>

      <div class="new-service-inline" *ngIf="showNewInline" role="dialog" aria-modal="true"
        aria-label="New External Connection">
        <div class="new-service-header">
          <wm-common-text [data]="{ text: 'New External Connection' }"></wm-common-text>
          <button class="modal-close" (click)="closeNewConnection()" aria-label="Close">
            <mat-icon>close</mat-icon>
          </button>
        </div>

        <form #newConnForm="ngForm" class="modal-form" (ngSubmit)="saveNewConnection()">

          <div class="row">
            <div class="col">
              <wm-common-dropdown
                class="full-width connection-type-dropdown"
                [data]="connectionTypeDropdownData"
                [(ngModel)]="newConnection.connectionType"
                (change)="onNewConnectionTypeChange($event)"
                name="new-connection-type"
                required>
              </wm-common-dropdown>

              <div class="text-danger small mt-1"
                *ngIf="newConnection.connectionType === 'ParcelData' && parcelDataExists">
                A Parcel Data Source has already been configured for this client. Edit that connection if you want to
                change
                the source of the Parcel Data.
              </div>
            </div>

            <ng-container *ngIf="newConnection.connectionType === 'ParcelData'">
              <div class="col">
                <mat-form-field appearance="outline" class="full-width mat-outline-select">
                  <mat-select panelClass="custom-select-panel" floatLabel="never" placeholder="Source"
                    [(ngModel)]="newConnectionSourceId" [compareWith]="compareIds" name="new-source" required
                    [disabled]="parcelDataExists">
                    <mat-option *ngFor="let s of parcelDataSources" [value]="s.sourceId">
                      {{ s.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </ng-container>

            <ng-container *ngIf="newConnection.connectionType === 'SecureFTP'">
              <div class="col">
                <wm-common-textfield 
                  class="full-width" 
                  [data]="{ label: 'Name', variant: 'outline' }" 
                  [(ngModel)]="newConnection.name" 
                  name="new-name" 
                  required>
                </wm-common-textfield>
              </div>
              <div class="col">
                <wm-common-textfield 
                  class="full-width" 
                  [data]="{ label: 'Host', variant: 'outline' }" 
                  [(ngModel)]="newConnection.host" 
                  name="new-host" 
                  required>
                </wm-common-textfield>
              </div>
              <div class="col">
                <wm-common-textfield 
                  class="full-width" 
                  [data]="{ label: 'Path', variant: 'outline' }" 
                  [(ngModel)]="newConnection.path" 
                  name="new-path">
                </wm-common-textfield>
              </div>
              <div class="col">
                <wm-common-textfield 
                  class="full-width" 
                  [data]="{ label: 'Username', variant: 'outline' }" 
                  [(ngModel)]="newConnection.username" 
                  name="new-username" 
                  required>
                </wm-common-textfield>
              </div>
              <div class="col">
                <wm-common-textfield 
                  class="full-width" 
                  [data]="{ label: 'Password', variant: 'outline', type: 'password' }" 
                  [(ngModel)]="newConnection.password" 
                  name="new-password" 
                  required>
                </wm-common-textfield>
              </div>
              <div class="row">
                <div class="col">
                  <button type="button" class="btn btn-default" style="background:#eee; color:#333; width: fit-content;"
                    (click)="testConnection(newConnection)">
                    Test Connection
                  </button>
                </div>
              </div>
            </ng-container>

          </div>
          <div class="error-message" *ngIf="errorMessage">{{ errorMessage }}</div>

          <div class="form-actions modal-actions">
            <button type="button" class="btn cancel" (click)="closeNewConnection()">CANCEL</button>
            <button type="submit" class="btn save"
              [disabled]="(newConnection.connectionType === 'ParcelData' && parcelDataExists) || newConnForm.invalid">
              SAVE
            </button>
          </div>
        </form>
      </div>

      <div class="services-list" [class.dimmed]="showNewInline">
        
        <div *ngIf="connections.length === 0" class="empty-state">
           <p>No connections configured.</p>
        </div>

        <div class="service-card" *ngFor="let conn of connections; let i = index" [class.expanded]="expandedState[i]">
          <div class="service-card-header" (click)="toggleAccordion(i)">
            <div class="service-title">{{ conn.name || 'Parcel Data' }}</div>

            <div class="header-actions" (click)="$event.stopPropagation()">
              <button class="icon-btn" title="Delete" (click)="deleteConnection(i, conn)">
                <mat-icon>delete_outline</mat-icon>
              </button>
              <button class="icon-btn chevron-btn" title="Expand / Collapse" (click)="toggleAccordion(i)">
                <mat-icon>{{ expandedState[i] ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</mat-icon>
              </button>
            </div>
          </div>

          <div class="service-card-body" *ngIf="expandedState[i]">
            <form #editConnForm="ngForm" class="service-form" (ngSubmit)="saveConnection(i, conn)">

              <div class="row">

                <div class="col">
                  <wm-common-dropdown
                    class="full-width connection-type-dropdown"
                    [data]="connectionTypeDropdownData"
                    [(ngModel)]="conn.connectionType"
                    (change)="onEditConnectionTypeChange(conn, $event)"
                    name="connection-type-{{i}}"
                    required>
                  </wm-common-dropdown>
                </div>

                <ng-container *ngIf="conn.connectionType === 'ParcelData'">
                  <div class="col">
                    <mat-form-field appearance="outline" class="full-width mat-outline-select">
                      <mat-select panelClass="custom-select-panel" floatLabel="never" placeholder="Source"
                        [(ngModel)]="conn['tempSourceId']" [compareWith]="compareIds" name="source-{{i}}" required>
                        <mat-option *ngFor="let s of parcelDataSources" [value]="s.sourceId">
                          {{ s.name }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </ng-container>

                <ng-container *ngIf="conn.connectionType === 'SecureFTP'">
                  <div class="col">
                    <wm-common-textfield 
                      class="full-width" 
                      [data]="{ label: 'Name', variant: 'outline' }" 
                      [(ngModel)]="conn.name" 
                      name="name-{{i}}" 
                      required>
                    </wm-common-textfield>
                  </div>
                  <div class="col">
                    <wm-common-textfield 
                      class="full-width" 
                      [data]="{ label: 'Host', variant: 'outline' }" 
                      [(ngModel)]="conn.host" 
                      name="host-{{i}}" 
                      required>
                    </wm-common-textfield>
                  </div>
                  <div class="col">
                    <wm-common-textfield 
                      class="full-width" 
                      [data]="{ label: 'Path', variant: 'outline' }" 
                      [(ngModel)]="conn.path" 
                      name="path-{{i}}">
                    </wm-common-textfield>
                  </div>
                  <div class="col">
                    <wm-common-textfield 
                      class="full-width" 
                      [data]="{ label: 'Username', variant: 'outline' }" 
                      [(ngModel)]="conn.username" 
                      name="username-{{i}}" 
                      required>
                    </wm-common-textfield>
                  </div>
                  <div class="col">
                    <wm-common-textfield 
                      class="full-width" 
                      [data]="{ label: 'Password', variant: 'outline', type: 'password' }" 
                      [(ngModel)]="conn.password" 
                      name="password-{{i}}" 
                      required>
                    </wm-common-textfield>
                  </div>
                  <div class="row">
                    <div class="col">
                      <button type="button" class="btn btn-default"
                        style="background:#eee; color:#333; width: fit-content;" (click)="testConnection(conn)">
                        Test Connection
                      </button>
                    </div>
                  </div>
                </ng-container>

              </div>
              <div class="form-actions">
                <button type="button" class="btn cancel" (click)="cancelEdit(i)">CANCEL</button>
                <button type="submit" class="btn save" [disabled]="editConnForm.invalid">SAVE</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>